const stageConfig = {
  AUTH_API_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-auth',
  PAYMENT_API_BASE_URL: 'https://gateway.sunrun.com/majstg-payment-service',
  ROLLBAR_TOKEN: 'e912239341d44a6bb6da41b3f518df8e',
  ROLLBAR_ENV: 'majstg',
  CONTENT_SERVICE_URL: 'https://6ug4dpat60.execute-api.us-west-2.amazonaws.com/prod',
  CONTENT_SERVICE_ACCESS_TOKEN: '_qfYT9HDQd69uxIdJzULAN9iSqI16YHQLobqrxKrsNQ',
  BUSINESS_ENV: 'majstg',
  CLIENT_HOST: 'majstg-my.sunrun.com',
  USER_API_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-user',
  QUESTION_ANSWER_API_URL: 'https://gateway.sunrun.com/majstg-question-answer',
  STATUS_TRACKER_API_URL: 'https://gateway.sunrun.com/majstg-status-tracker',
  SERVICE_TRANSFER_API_BASE_URL: 'https://gateway.sunrun.com/majstg-service-transfer',
  SUPPORT_API_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-support',
  REFERRAL_API_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-referral',
  WEATHER_API_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-weather',
  CASES_API_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-cases',
  PERFORMANCE_BASE_URL: 'https://gateway.sunrun.com/majstg-performance-api',
  NOTIFICATION_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-notifications',
  GRID_SERVICE_BASE_URL: 'https://gateway.sunrun.com/majstg-portal-grid-services',
  SPLAT_CAP_BASE_URL: 'https://gateway.sunrun.com/majstg-splat-cap',
  SPLAT_BASE_URL: 'https://majstg-go.sunrun.com',
  MIXPANEL_KEY: 'e8580189b3d5562922e3c5be0b6a10e0',
  ENABLE_GRID_CHARTS: false,
  INCONTACT_CHAT_LINK: 'https://home-c16.incontact.com/incontact/chatclient/chatclient.aspx?poc=96be2f9b-34ff-47ae-b260-3923807d3bb3&bu=4595152',
  GOOGLE_MAP_API_KEY: 'AIzaSyAErcXuZ-i5rrWeP9ZAggzPNU8Ei2yVaOw',
  GOOGLE_ANALYTICS_TRACKING_ID: 'UA-4657551-25',
  GOOGLE_TAG_MANAGER_ID: 'GTM-TKLD6X7',
  OPTIMIZE_ID: 'GTM-W8WR847',
  ENABLE_SHOW_CCMETHOD_FROM_PREPAID: false,
  ENABLE_CHART_DATA_TYPES: true,
  FORCE_ENABLE_CHART_OPTIONS: true,
  ENABLE_BATTERY_OPTION: false,
  ENABLE_IN_CONTACT_CHAT: true,
  ENABLE_CASE_TABLE: true,
  ENABLE_SYSTEM_STATUS: true,
  ENABLE_DASHBOARD_NOTIFICATION_CARDS: true,
  PORTAL_SUPPORT_API_KEY: 'frRd9DV2qJ9lkwyLgvUtY8lmI4xZgC6JOc6xyeq8',
  ENABLE_SDGE_PAGE: true,
  ENABLE_SDGE_TESTING_MESSAGE: true,
  ENABLE_BATTERY_RETRO_SPLAT_LINK: true,
  ENABLE_VIEW_DOC_BUTTON_STATUS_TRACKER: true,
  FLAGSMITH_ENV_ID: 'KWbiYDFLCbXWuHChKnJfez',
};

export default stageConfig;
